/**
 * Configuration par compagnie pour le routeur.
 *
 * Chaque compagnie définit :
 * - auth : stratégie d'authentification ('msal' ou 'oidc')
 * - paymentProvider : provider de paiement pour le profil ('none', 'stripe', 'globalPayments', 'paysafe', 'payfacto')
 * - extraRoutes : liste de clés de routes additionnelles spécifiques à la compagnie
 * - translateOverrides : surcharges de meta.translate pour certaines routes (optionnel)
 */
export const companyConfig = {
  demo: {
    auth: 'msal',
    paymentProvider: 'stripe',
    extraRoutes: ['payments-profile', 'other-groupes', 'other-adminClients', 'other-devices', 'payments-account', 'payments-customer-list', 'payments-customer-transaction-list', 'payments-transaction-list', 'payments-transaction-view'],
  },
  uqam: {
    auth: 'oidc',
    paymentProvider: 'globalPayments',
    extraRoutes: ['usersmanagement-roles', 'usersmanagement-roles-users', 'usersmanagement-users'], // User Management pas dans le menu
  },
  uqam_msal: {
    auth: 'msal',
    paymentProvider: 'globalPayments',
    extraRoutes: [],
    translateOverrides: {
      'other-parameters': 'sidebar.operation',
      'other-messages': 'sidebar.messages',
      'other-list': 'sidebar.list',
      'other-toggles': 'sidebar.toggles',
    },
  },
  enap: {
    auth: 'msal',
    paymentProvider: 'paysafe',
    extraRoutes: [],
    translateOverrides: {
      'other-parameters': 'sidebar.operation',
      'other-messages': 'sidebar.messages',
      'other-list': 'sidebar.list',
      'other-toggles': 'sidebar.toggles',
    },
  },
  ets: {
    auth: 'msal',
    paymentProvider: 'payfacto',
    extraRoutes: ['other-groupes', 'other-adminClients'],
  },
  mcgill: {
    auth: 'msal',
    paymentProvider: 'none',
    extraRoutes: ['other-devices'],
    translateOverrides: {
      'other-parameters': 'sidebar.operation',
      'other-messages': 'sidebar.messages',
      'other-list': 'sidebar.list',
      'other-toggles': 'sidebar.toggles',
      'other-devices': 'sidebar.devices',
    },
  },
}
